export default function ArrowLeftIcon({ color }) {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M4 12H21" stroke={color} />
      <path d="M10 18L4 12L10 6.00002" stroke={color} />
    </svg>
  )
}
